var map = {
	"./0 a.png": 2384,
	"./0.png": 2385,
	"./1 a.png": 2386,
	"./1.png": 2387,
	"./2 a.png": 2388,
	"./2.png": 2389,
	"./3 a.png": 2390,
	"./3.png": 2391,
	"./4 a.png": 2392,
	"./4.png": 2393,
	"./5 a.png": 2394,
	"./5.png": 2395,
	"./6 a.png": 2396,
	"./6.png": 2397,
	"./7 a.png": 2398,
	"./7.png": 2399,
	"./8 a.png": 2400,
	"./8.png": 2401,
	"./9 a.png": 2402,
	"./9.png": 2403,
	"./BG new 2.png": 2404,
	"./CEX.png": 2405,
	"./Copy of token-05.png": 2406,
	"./DEX.png": 2407,
	"./FBlogo.png": 2408,
	"./Group 126.png": 857,
	"./Group 127.png": 2409,
	"./Group 128.png": 2410,
	"./Group 129.png": 2411,
	"./Group 130.png": 2412,
	"./Group 131.png": 2413,
	"./Group 160.png": 2414,
	"./Group 161.png": 2415,
	"./Group 164.png": 2416,
	"./Group 4.png": 2417,
	"./Group 5.png": 2418,
	"./Group 6.png": 2419,
	"./Group 7.png": 2420,
	"./Group-5.png": 2421,
	"./Group-6.png": 2422,
	"./Group-7.png": 2423,
	"./Group120.png": 860,
	"./Indexx Token.png": 2424,
	"./IndexxToken.png": 2425,
	"./Polygon.png": 2426,
	"./about.png": 2427,
	"./affiliate.png": 2428,
	"./aline.png": 2429,
	"./assets/1.png": 2430,
	"./assets/2.png": 2431,
	"./assets/3.png": 2432,
	"./assets/4.png": 2433,
	"./assets/ADA.png": 2434,
	"./assets/ALGO.png": 2435,
	"./assets/BNB.png": 2436,
	"./assets/BTC.png": 2437,
	"./assets/BTCB.png": 2438,
	"./assets/Ball-024-01png.png": 2439,
	"./assets/CEX.png": 2440,
	"./assets/DEX.png": 2441,
	"./assets/ENJ.png": 2442,
	"./assets/ETH.png": 2443,
	"./assets/FBlogo.png": 2444,
	"./assets/FTT.png": 2445,
	"./assets/IN500.png": 2446,
	"./assets/INEX.png": 2447,
	"./assets/INXC.png": 2448,
	"./assets/INXP.png": 2449,
	"./assets/IUSD+.png": 2450,
	"./assets/IUSD.png": 2451,
	"./assets/Indexx Token.png": 2452,
	"./assets/LTC.png": 2453,
	"./assets/ML.png": 2454,
	"./assets/Polygon.png": 2455,
	"./assets/UI-bg.png": 2456,
	"./assets/UNI.png": 2457,
	"./assets/USD.png": 2458,
	"./assets/Wales.png": 2459,
	"./assets/about.png": 2460,
	"./assets/affiliate.png": 2461,
	"./assets/arrows.png": 2462,
	"./assets/bank.png": 2463,
	"./assets/bg33.png": 2464,
	"./assets/bgForUi.png": 2465,
	"./assets/binancew.png": 2466,
	"./assets/blog.png": 2467,
	"./assets/bnb1.png": 2468,
	"./assets/bnblogo2.png": 2469,
	"./assets/cam2 copy.png": 2470,
	"./assets/cam2.png": 2471,
	"./assets/career.png": 2472,
	"./assets/clock.png": 2473,
	"./assets/coinbase2.png": 2474,
	"./assets/confirm.png": 2475,
	"./assets/confirm1.png": 2476,
	"./assets/dex4t2e copy.png": 2477,
	"./assets/dex4t2e.png": 2478,
	"./assets/dollar.png": 2479,
	"./assets/earn.png": 2480,
	"./assets/eth1.png": 2481,
	"./assets/exchange.png": 2482,
	"./assets/exchange1.png": 2483,
	"./assets/exgcoin.png": 2484,
	"./assets/exghands.png": 2485,
	"./assets/fb.png": 2486,
	"./assets/fortune Daily.png": 2487,
	"./assets/fortune-10.png": 2488,
	"./assets/fortune-12.png": 2489,
	"./assets/four.png": 2490,
	"./assets/graph.png": 2491,
	"./assets/green.png": 2492,
	"./assets/green2.png": 2493,
	"./assets/green3.png": 2494,
	"./assets/green4.png": 2495,
	"./assets/header-icons/Company/about.png": 2496,
	"./assets/header-icons/Company/affiliate.png": 2497,
	"./assets/header-icons/Company/blog.png": 2498,
	"./assets/header-icons/Company/career.png": 2499,
	"./assets/header-icons/Company/howitworks.png": 2500,
	"./assets/header-icons/Company/hybrid.png": 2501,
	"./assets/header-icons/Earn/iGrow.png": 2502,
	"./assets/header-icons/Earn/t2e.png": 2503,
	"./assets/header-icons/Fortune/fortune.png": 2504,
	"./assets/header-icons/Fortune/hedge.png": 2505,
	"./assets/header-icons/Products/CEX.png": 2506,
	"./assets/header-icons/Products/DEX.png": 2507,
	"./assets/header-icons/Products/IndexxToken.png": 2508,
	"./assets/header.png": 2509,
	"./assets/hedge.png": 2510,
	"./assets/how it works.png": 2511,
	"./assets/hybrid.png": 2512,
	"./assets/iGrow.png": 2513,
	"./assets/indexx.png": 2514,
	"./assets/indexx500.png": 2515,
	"./assets/indexxGrey.png": 2516,
	"./assets/inst2.png": 2517,
	"./assets/ladySwapIcon.png": 2518,
	"./assets/logo.png": 2519,
	"./assets/logonew.png": 2520,
	"./assets/metamask.png": 2521,
	"./assets/need.png": 2522,
	"./assets/new.png": 2523,
	"./assets/newFooter.png": 2524,
	"./assets/no11.png": 2525,
	"./assets/no22.png": 2526,
	"./assets/no3.png": 2527,
	"./assets/one.png": 2528,
	"./assets/pending.png": 2529,
	"./assets/pending1.png": 2530,
	"./assets/petFooter.png": 2531,
	"./assets/please.png": 2532,
	"./assets/qr.png": 2533,
	"./assets/question.png": 2534,
	"./assets/redit2.png": 2535,
	"./assets/send1.png": 2536,
	"./assets/sending.png": 2537,
	"./assets/swap.png": 2538,
	"./assets/telegram.png": 2539,
	"./assets/text.png": 2540,
	"./assets/three.png": 2541,
	"./assets/trust.png": 2542,
	"./assets/twit2.png": 2543,
	"./assets/two.png": 2544,
	"./assets/vector.png": 2545,
	"./assets/wallet.png": 2546,
	"./assets/white copy.png": 2547,
	"./assets/white.png": 2548,
	"./assets/yt1.png": 2549,
	"./bank.png": 2550,
	"./bg33.png": 2551,
	"./blog.png": 2552,
	"./buy.png": 2553,
	"./buyi.png": 2554,
	"./cam2.png": 2555,
	"./career.png": 2556,
	"./changed.png": 2557,
	"./checkorange.png": 2558,
	"./cross.png": 2559,
	"./dex4t2e.png": 2560,
	"./down.png": 2561,
	"./editt.png": 2562,
	"./fortune-10.png": 2563,
	"./fortune-16.png": 2564,
	"./fortune.png": 2565,
	"./fourthh.png": 2566,
	"./gggg.png": 1139,
	"./graph.png": 2567,
	"./hands-12.png": 2568,
	"./hands-20.png": 2569,
	"./hands-29.png": 2570,
	"./hedge.png": 2571,
	"./home_page_logo.png": 2572,
	"./howitworks.png": 2573,
	"./htp.png": 2574,
	"./htp2.png": 2575,
	"./htp2n.png": 2576,
	"./htpf.png": 1136,
	"./hybrid.png": 2577,
	"./iGrow.png": 2578,
	"./icons.png": 2579,
	"./image1.png": 2580,
	"./image2.png": 2581,
	"./image3.png": 2582,
	"./indexx.png": 2583,
	"./indexxGrey.png": 2584,
	"./inst2.png": 2585,
	"./lady.png": 2586,
	"./ladySwapIcon.png": 2587,
	"./left.png": 858,
	"./left22.png": 2588,
	"./log.png": 1140,
	"./logo.png": 2589,
	"./mid.png": 2590,
	"./need copy.png": 2591,
	"./need.png": 2592,
	"./new.png": 2593,
	"./newFooter.png": 2594,
	"./pf.png": 2595,
	"./pfF.png": 2596,
	"./pfp.png": 2597,
	"./pfp2.png": 2598,
	"./ppp.png": 2599,
	"./prize funds new.png": 1138,
	"./purple-1.png": 2600,
	"./purple.png": 2601,
	"./redit2.png": 2602,
	"./right.png": 859,
	"./right22.png": 2603,
	"./secondd.png": 2604,
	"./stars 1.png": 2605,
	"./t2e.png": 2606,
	"./telegram.png": 2607,
	"./thirdd.png": 2608,
	"./ticket.png": 2609,
	"./token.png": 2610,
	"./tokenimgg.png": 2611,
	"./top.png": 861,
	"./topp.png": 2612,
	"./twit2.png": 2613,
	"./wc.png": 2614,
	"./wcF.png": 1137,
	"./whale4.png": 1141,
	"./white.png": 2615,
	"./x orange.png": 2616,
	"./yt1.png": 2617
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 428;